namespace $ {

	export class $shm_hitalama_map_widget_entity_ai_request extends $giper_baza_entity.with({

		Request_type: $giper_baza_atom_text,
		Parent_id: $giper_baza_atom_text,
		Obj: $giper_baza_atom_dict,

	}) {

		@ $mol_mem
		request_type( next?: string ) {
			return this.Request_type(next)?.val(next) ?? ''
		}

		@ $mol_mem
		parent_id( next?: string ) {
			return this.Parent_id(next)?.val(next) ?? ''
		}

		@ $mol_mem
		obj( next?: any ) {
			return this.Obj(next)?.val(next)
		}

	}

}
